export const tabSwitcher = {
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
};
